export const PromotionTypes = {
    //Free Rounds Promotions
    GET_FREE_ROUNDS_PROMOTIONS_REQUEST: 'GET_FREE_ROUNDS_PROMOTIONS_REQUEST',
    GET_FREE_ROUNDS_PROMOTIONS_SUCCESS: 'GET_FREE_ROUNDS_PROMOTIONS_SUCCESS',
    GET_FREE_ROUNDS_PROMOTIONS_FAILED: 'GET_FREE_ROUNDS_PROMOTIONS_FAILED',

    CREATE_FREE_ROUNDS_PROMOTION_REQUEST: 'CREATE_FREE_ROUNDS_PROMOTION_REQUEST',
    CREATE_FREE_ROUNDS_PROMOTION_SUCCESS: 'CREATE_FREE_ROUNDS_PROMOTION_SUCCESS',
    CREATE_FREE_ROUNDS_PROMOTION_FAILED: 'CREATE_FREE_ROUNDS_PROMOTION_FAILED',

    GET_FREE_ROUNDS_CAMPAIGN_REQUEST: 'GET_FREE_ROUNDS_CAMPAIGN_REQUEST',
    GET_FREE_ROUNDS_CAMPAIGN_SUCCESS: 'GET_FREE_ROUNDS_CAMPAIGN_SUCCESS',
    GET_FREE_ROUNDS_CAMPAIGN_FAILED: 'GET_FREE_ROUNDS_CAMPAIGN_FAILED',

    GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_REQUEST: 'GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_REQUEST',
    GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_SUCCESS: 'GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_SUCCESS',
    GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_FAILED: 'GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_FAILED',

    GET_FREE_ROUNDS_CAMPAIGN_GAMES_REQUEST: 'GET_FREE_ROUNDS_CAMPAIGN_GAMES_REQUEST',
    GET_FREE_ROUNDS_CAMPAIGN_GAMES_SUCCESS: 'GET_FREE_ROUNDS_CAMPAIGN_GAMES_SUCCESS',
    GET_FREE_ROUNDS_CAMPAIGN_GAMES_FAILED: 'GET_FREE_ROUNDS_CAMPAIGN_GAMES_FAILED',

    EDIT_FREE_ROUNDS_CAMPAIGN_REQUEST: 'EDIT_FREE_ROUNDS_CAMPAIGN_REQUEST',
    EDIT_FREE_ROUNDS_CAMPAIGN_SUCCESS: 'EDIT_FREE_ROUNDS_CAMPAIGN_SUCCESS',
    EDIT_FREE_ROUNDS_CAMPAIGN_FAILED: 'EDIT_FREE_ROUNDS_CAMPAIGN_FAILED',

    GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_REQUEST: 'GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_REQUEST',
    GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_SUCCESS: 'GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_SUCCESS',
    GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_FAILED: 'GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_FAILED',

    //Awarded Promotions
    GET_AWARDED_PROMOTIONS_REQUEST: 'GET_AWARDED_PROMOTIONS_REQUEST',
    GET_AWARDED_PROMOTIONS_SUCCESS: 'GET_AWARDED_PROMOTIONS_SUCCESS',
    GET_AWARDED_PROMOTIONS_FAILED: 'GET_AWARDED_PROMOTIONS_SUCCESS_FAILED',

    CREATE_AWARDED_PROMOTION_REQUEST: 'CREATE_AWARDED_PROMOTION_REQUEST',
    CREATE_AWARDED_PROMOTION_SUCCESS: 'CREATE_AWARDED_PROMOTION_SUCCESS',
    CREATE_AWARDED_PROMOTION_FAILED: 'CREATE_AWARDED_PROMOTION_FAILED',
    
    GET_AWARDED_CAMPAIGN_REQUEST: 'GET_AWARDED_CAMPAIGN_REQUEST',
    GET_AWARDED_CAMPAIGN_SUCCESS: 'GET_AWARDED_CAMPAIGN_SUCCESS',
    GET_AWARDED_CAMPAIGN_FAILED: 'GET_AWARDED_CAMPAIGN_FAILED',

    GET_AWARDED_CAMPAIGN_PLAYERS_REQUEST: 'GET_AWARDED_CAMPAIGN_PLAYERS_REQUEST',
    GET_AWARDED_CAMPAIGN_PLAYERS_SUCCESS: 'GET_AWARDED_CAMPAIGN_PLAYERS_SUCCESS',
    GET_AWARDED_CAMPAIGN_PLAYERS_FAILED: 'GET_AWARDED_CAMPAIGN_PLAYERS_FAILED',

    GET_AWARDED_CAMPAIGN_GAMES_REQUEST: 'GET_AWARDED_CAMPAIGN_GAMES_REQUEST',
    GET_AWARDED_CAMPAIGN_GAMES_SUCCESS: 'GET_AWARDED_CAMPAIGN_GAMES_SUCCESS',
    GET_AWARDED_CAMPAIGN_GAMES_FAILED: 'GET_AWARDED_CAMPAIGN_GAMES_FAILED',

    EDIT_AWARDED_CAMPAIGN_REQUEST: 'EDIT_AWARDED_CAMPAIGN_REQUEST',
    EDIT_AWARDED_CAMPAIGN_SUCCESS: 'EDIT_AWARDED_CAMPAIGN_SUCCESS',
    EDIT_AWARDED_CAMPAIGN_FAILED: 'EDIT_AWARDED_CAMPAIGN_FAILED',

    GET_AWARDED_GAMES_BY_PROMOTION_PRICE_REQUEST: 'GET_AWARDED_GAMES_BY_PROMOTION_PRICE_REQUEST',
    GET_AWARDED_GAMES_BY_PROMOTION_PRICE_SUCCESS: 'GET_AWARDED_GAMES_BY_PROMOTION_PRICE_SUCCESS',
    GET_AWARDED_GAMES_BY_PROMOTION_PRICE_FAILED: 'GET_AWARDED_GAMES_BY_PROMOTION_PRICE_FAILED',
    
    //Shared
    RESET_NEW_PROMOTION: 'RESET_NEW_PROMOTION',
    IMPORT_PLAYERS_CSV_REQUEST: 'IMPORT_PLAYERS_CSV_REQUEST',
    IMPORT_PLAYERS_CSV_SUCCESS: 'IMPORT_PLAYERS_CSV_SUCCESS',
    IMPORT_PLAYERS_CSV_FAILED: 'IMPORT_PLAYERS_CSV_FAILED',
    EXPORT_PLAYERS_CSV_REQUEST: 'EXPORT_PLAYERS_CSV_REQUEST',
    EXPORT_PLAYERS_CSV_SUCCESS: 'EXPORT_PLAYERS_CSV_SUCCESS',
    EXPORT_PLAYERS_CSV_FAILED: 'EXPORT_PLAYERS_CSV_FAILED',
    ADD_PLAYER_TO_CAMPAIGN_REQUEST: 'ADD_PLAYER_TO_CAMPAIGN_REQUEST',
    ADD_PLAYER_TO_CAMPAIGN_SUCCESS: 'ADD_PLAYER_TO_CAMPAIGN_SUCCESS',
    ADD_PLAYER_TO_CAMPAIGN_FAILED: 'ADD_PLAYER_TO_CAMPAIGN_FAILED',
    REMOVE_PLAYERS_FROM_CAMPAIGN_REQUEST: 'REMOVE_PLAYERS_FROM_CAMPAIGN_REQUEST',
    REMOVE_PLAYERS_FROM_CAMPAIGN_SUCCESS: 'REMOVE_PLAYERS_FROM_CAMPAIGN_SUCCESS',
    REMOVE_PLAYERS_FROM_CAMPAIGN_FAILED: 'REMOVE_PLAYERS_FROM_CAMPAIGN_FAILED',
    ADD_GAME_TO_CAMPAIGN_REQUEST: 'ADD_GAME_TO_CAMPAIGN_REQUEST',
    ADD_GAME_TO_CAMPAIGN_SUCCESS: 'ADD_GAME_TO_CAMPAIGN_SUCCESS',
    ADD_GAME_TO_CAMPAIGN_FAILED: 'ADD_GAME_TO_CAMPAIGN_FAILED',
    REMOVE_GAME_FROM_CAMPAIGN_REQUEST: 'REMOVE_GAME_FROM_CAMPAIGN_REQUEST',
    REMOVE_GAME_FROM_CAMPAIGN_SUCCESS: 'REMOVE_GAME_FROM_CAMPAIGN_SUCCESS',
    REMOVE_GAME_FROM_CAMPAIGN_FAILED: 'REMOVE_GAME_FROM_CAMPAIGN_FAILED',
    CLONE_CAMPAIGN_REQUEST: 'CLONE_CAMPAIGN_REQUEST',
    CLONE_CAMPAIGN_SUCCESS: 'CLONE_CAMPAIGN_SUCCESS',
    CLONE_CAMPAIGN_FAILED: 'CLONE_CAMPAIGN_FAILED',
    DELETE_CAMPAIGN_REQUEST: 'DELETE_CAMPAIGN_REQUEST',
    DELETE_CAMPAIGN_SUCCESS: 'DELETE_CAMPAIGN_SUCCESS',
    DELETE_CAMPAIGN_FAILED: 'DELETE_CAMPAIGN_FAILED',
    TERMINATE_CAMPAIGN_REQUEST: 'TERMINATE_CAMPAIGN_REQUEST',
    TERMINATE_CAMPAIGN_SUCCESS: 'TERMINATE_CAMPAIGN_SUCCESS',
    TERMINATE_CAMPAIGN_FAILED: 'TERMINATE_CAMPAIGN_FAILED',
    CLEAR_CAMPAIGN_DATA_REQUEST: 'CLEAR_CAMPAIGN_DATA_REQUEST',
    CREATE_PROMOTION_WITH_CSV_REQUEST: 'CREATE_PROMOTION_WITH_CSV_REQUEST',
    CREATE_PROMOTION_WITH_CSV_SUCCESS: 'CREATE_PROMOTION_WITH_CSV_SUCCESS',
    CREATE_PROMOTION_WITH_CSV_FAILED: 'CREATE_PROMOTION_WITH_CSV_FAILED',
};

//Free Rounds Promotions
export const getFreeRoundsPromotions = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_PROMOTIONS_REQUEST,
    payload,
});
export const getFreeRoundsPromotionsSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_PROMOTIONS_SUCCESS,
    payload,
});

export const createFreeRoundsPromotion = (payload?: any) => ({
    type: PromotionTypes.CREATE_FREE_ROUNDS_PROMOTION_REQUEST,
    payload,
});
export const createFreeRoundsPromotionSuccess = (payload?: any) => ({
    type: PromotionTypes.CREATE_FREE_ROUNDS_PROMOTION_SUCCESS,
    payload,
});

export const getFreeRoundsCampaign = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_REQUEST,
    payload,
});
export const getFreeRoundsCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_SUCCESS,
    payload,
});

export const getFreeRoundsCampaignPlayers = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_REQUEST,
    payload,
});
export const getFreeRoundsCampaignPlayersSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_PLAYERS_SUCCESS,
    payload,
});

export const getFreeRoundsCampaignGames = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_GAMES_REQUEST,
    payload,
});
export const getFreeRoundsCampaignGamesSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_CAMPAIGN_GAMES_SUCCESS,
    payload,
});

export const editFreeRoundsCampaign = (payload?: any) => ({
    type: PromotionTypes.EDIT_FREE_ROUNDS_CAMPAIGN_REQUEST,
    payload,
});
export const editFreeRoundsCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.EDIT_FREE_ROUNDS_CAMPAIGN_SUCCESS,
    payload,
});

export const getFreeRoundsGamesByPromotionPrice = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_REQUEST,
    payload,
});
export const getFreeRoundsGamesByPromotionPriceSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_FREE_ROUNDS_GAMES_BY_PROMOTION_PRICE_SUCCESS,
    payload,
});


//Awarded Promotions
export const getAwardedPromotions = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_PROMOTIONS_REQUEST,
    payload,
});
export const getAwardedPromotionsSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_PROMOTIONS_SUCCESS,
    payload,
});

export const createAwardedPromotion = (payload?: any) => ({
    type: PromotionTypes.CREATE_AWARDED_PROMOTION_REQUEST,
    payload,
});
export const createAwardedPromotionSuccess = (payload?: any) => ({
    type: PromotionTypes.CREATE_AWARDED_PROMOTION_SUCCESS,
    payload,
});

export const getAwardedCampaign = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_REQUEST,
    payload,
});
export const getAwardedCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_SUCCESS,
    payload,
});

export const getAwardedCampaignPlayers = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_PLAYERS_REQUEST,
    payload,
});
export const getAwardedCampaignPlayersSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_PLAYERS_SUCCESS,
    payload,
});

export const editAwardedCampaign = (payload?: any) => ({
    type: PromotionTypes.EDIT_AWARDED_CAMPAIGN_REQUEST,
    payload,
});
export const editAwardedCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.EDIT_AWARDED_CAMPAIGN_SUCCESS,
    payload,
});

export const getAwardedCampaignGames = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_GAMES_REQUEST,
    payload,
});
export const getAwardedCampaignGamesSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_CAMPAIGN_GAMES_SUCCESS,
    payload,
});

export const getAwardedGamesByPromotionPrice = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_GAMES_BY_PROMOTION_PRICE_REQUEST,
    payload,
});
export const getAwardedGamesByPromotionPriceSuccess = (payload?: any) => ({
    type: PromotionTypes.GET_AWARDED_GAMES_BY_PROMOTION_PRICE_SUCCESS,
    payload,
});

//Shared
export const deleteCampaign = (payload?: any) => ({
    type: PromotionTypes.DELETE_CAMPAIGN_REQUEST,
    payload,
});
export const clearCampaignData = (payload?: any) => ({
    type: PromotionTypes.CLEAR_CAMPAIGN_DATA_REQUEST,
    payload,
});
export const deleteCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.DELETE_CAMPAIGN_SUCCESS,
    payload,
});
export const terminateCampaign = (payload?: any) => ({
    type: PromotionTypes.TERMINATE_CAMPAIGN_REQUEST,
    payload,
});
export const terminateCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.TERMINATE_CAMPAIGN_SUCCESS,
    payload,
});
export const cloneCampaign = (payload?: any) => ({
    type: PromotionTypes.CLONE_CAMPAIGN_REQUEST,
    payload,
});
export const cloneCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.CLONE_CAMPAIGN_SUCCESS,
    payload,
});
export const resetNewPromotion = (payload?: any) => ({
    type: PromotionTypes.RESET_NEW_PROMOTION,
    payload,
});
export const exportPlayersCsv = (payload?: any) => ({
    type: PromotionTypes.EXPORT_PLAYERS_CSV_REQUEST,
    payload,
});
export const exportPlayersCsvSuccess = (payload?: any) => ({
    type: PromotionTypes.EXPORT_PLAYERS_CSV_SUCCESS,
    payload,
});
export const importPlayersCsv = (payload?: any) => ({
    type: PromotionTypes.IMPORT_PLAYERS_CSV_REQUEST,
    payload,
});
export const importPlayersCsvSuccess = (payload?: any) => ({
    type: PromotionTypes.IMPORT_PLAYERS_CSV_SUCCESS,
    payload,
});
export const addPlayerToCampaign = (payload?: any) => ({
    type: PromotionTypes.ADD_PLAYER_TO_CAMPAIGN_REQUEST,
    payload,
});
export const addPlayerToCampaignCsvSuccess = (payload?: any) => ({
    type: PromotionTypes.ADD_PLAYER_TO_CAMPAIGN_SUCCESS,
    payload,
});
export const removePlayersFromCampaign = (payload?: any) => ({
    type: PromotionTypes.REMOVE_PLAYERS_FROM_CAMPAIGN_REQUEST,
    payload,
});
export const removePlayersFromCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.REMOVE_PLAYERS_FROM_CAMPAIGN_SUCCESS,
    payload,
});
export const addGameToCampaign = (payload?: any) => ({
    type: PromotionTypes.ADD_GAME_TO_CAMPAIGN_REQUEST,
    payload,
});
export const addGameToCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.ADD_GAME_TO_CAMPAIGN_SUCCESS,
    payload,
});
export const removeGameFromCampaign = (payload?: any) => ({
    type: PromotionTypes.REMOVE_GAME_FROM_CAMPAIGN_REQUEST,
    payload,
});
export const removeGameFromCampaignSuccess = (payload?: any) => ({
    type: PromotionTypes.REMOVE_GAME_FROM_CAMPAIGN_SUCCESS,
    payload,
});
